import React, {useMemo, useRef, useState} from 'react';
import {useQueryClient} from "react-query";
import DataGrid from "../../../controls/DataGrid";
import {withStyles} from "@material-ui/core/styles";
import { useBookingHistory } from "../../../services/booking"
import moment from "moment/moment";
import {LightTooltip} from "../../../controls";


const styles = {
  bookingQueueFormHistoryCell: {
    fontSize: 10,
    paddingLeft: "3px !important",
    paddingRight: "3px !important",
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: 300,
    width: 200
  },
  bookingQueueFormHistoryHeader: {
    fontSize: 12,
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
  }
};


const HistoryGrid = (_props) => {
  const props = {
    ..._props
  }
  const [state, setState] = useState({
    canEdit: props.canEdit||false,
  });

  const { classes } = props;

  const queryClient = useQueryClient();
  const extraKeys = [props.bookingUuid];

  const dataGridRef = useRef();
  const bookingHistory = useBookingHistory({queryClient, extraKeys});

  const getColumns = (props) => {
    const baseColumn = {
      options: {
        cellClass: classes.bookingQueueFormHistoryCell,
        headerClass: classes.bookingQueueFormHistoryHeader,
      },
      editable: state.canEdit,
    };

    return [
      {
        ...baseColumn,
        headerName: "Time",
        field: "lastUpdate",
        width: 80,
        valueFormatter: (params)=> {
          return params.value ? moment.utc(params.value).format("DD/MM/YYYY") : "";
        }
      },
      {
        ...baseColumn,
        headerName: "Details",
        field: "action",
        tooltipField: 'action',
        tooltipComponentParams: { color: '#060606' },
        flex: 1,
      },
    ];
  };

  return (
    <div style={{width: props.width?props.width:"100%", ...props.style}}>
      <DataGrid
        title="Audit Trail"
        ref={dataGridRef}
        columns={getColumns({canEdit: state.canEdit})}
        rows={bookingHistory.data}
        height={props.height||`calc(100vh - ${(290)}px)`}
        options={{
          singleClickEdit: true,
          editType:'fullRow',
          tooltipShowDelay: 0,
          tooltipHideDelay: 2000,
          //enableBrowserTooltips: true,
          onCellValueChanged: ()=>{}, //prevent default onCellValueChanged
          defaultColDef: {
            editable: false,
            resizable: false,
            menuTabs: []
          },
        }}
      />
    </div>
  );

}

export default withStyles(styles)(HistoryGrid);
